import React from 'react'
import { ErrorBoundary } from '@sainsburys-tech/bolt'
import CMSComponents, { components, GetComponent } from '@sainsburys-tech/bolt-cms-components'
import { connect } from 'react-redux'
import * as Styled from './HandcraftedToYourNeeds.styles'

const HandcraftedToYourNeeds = ({ content }) => {
  return (
    content && (
      <Styled.Container data-test='handcrafted-container'>
        <Styled.HandcraftedToYourNeeds className='container'>
          <CMSComponents components={components}>
            <ErrorBoundary>
              {content.map((item, index) => {
                return <GetComponent {...item} key={`cms-handcrafted-${index}`} />
              })}
            </ErrorBoundary>
          </CMSComponents>
        </Styled.HandcraftedToYourNeeds>
      </Styled.Container>
    )
  )
}

const mapStateToProps = state => {
  const { cms } = state

  const props = {
    content: cms.mto.handcrafted
  }

  return props
}

export default connect(mapStateToProps)(HandcraftedToYourNeeds)
export { HandcraftedToYourNeeds }
